// src/components/Loading.js
import React from 'react';
import { HashLoader } from 'react-spinners';

const Loading = () => (
  <div style={styles.container}>
    <HashLoader size={50} color="#007bff" />
  </div>
);

const styles = {
  container: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional: Semi-transparent background
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
};

export default Loading;
